import { AddressCard, ContactFormWrapper, FormRow, PageContent, PrimaryFormButton, RedStar } from "./styles"
import { Input } from "../../components/input/Input"
import { Textarea } from "../../components/textarea/Textarea"
import { P } from "../../components/p/P"
import { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import emailjs from 'emailjs-com';

export const ContactForm = () => {
    const [ isChecked, setIsChecked ] = useState(false)
    const [ isConsentChecked, setIsConsentChecked ] = useState(false)

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs.send(
            process.env.REACT_APP_SERVICE_ID, // Replace with your EmailJS Service ID
            process.env.REACT_APP_CONTACT_TEMPLATE_ID, // Replace with your EmailJS Template ID
            {
                first_name: e.target.elements[0].value,
                last_name: e.target.elements[1].value,
                email: e.target.elements[2].value,
                mobile: e.target.elements[3].value,
                message: e.target.elements[4].value,
                isCommunicationConsentProvided: isConsentChecked ? 'Yes' : 'No',
                areConditionsAccepted: isChecked ? 'Yes' : 'No'
            },
            process.env.REACT_APP_USER_ID // Replace with your EmailJS User ID
        ).then((response) => {
            console.log('SUCCESS!', response.status, response.text);
            // alert('Email sent successfully!');
        }, (err) => {
            console.log('FAILED', err);
            // alert('Failed to send email!');
        });

        // Reset the form
        document.getElementById('contact-form').reset();
    }
        
    return (
        <PageContent>
            <ContactFormWrapper id='contact-form' onSubmit={handleSubmit}>
                <h2 style={{color:'#3b82f6'}}>Send us a message</h2>
                <br />
                <FormRow>
                    <Input type='text' placeholder='First Name*' />
                    <Input type='text' placeholder='Last Name*' />
                </FormRow>
                <FormRow>
                    <Input type='email' placeholder='Email*' />
                    <Input type='mobile' placeholder='Phone*' />
                </FormRow>
                <Textarea placeholder='Message' rows={5} />
                <br /><br />

                <input 
                    type='checkbox' 
                    style={{transform: 'scale(1.5)'}} 
                    checked={isConsentChecked}
                    onChange={() => setIsConsentChecked(!isConsentChecked)}
                    />
                &nbsp;&nbsp;
                <label>I consent to receiving RCS, WhatsApp, Email or SMS from CELESTE.</label>

                <br /><br />

                <input 
                    type='checkbox' 
                    style={{transform: 'scale(1.5)'}} 
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                    />
                &nbsp;&nbsp;
                <label>
                    <RedStar>*</RedStar>
                    I have reviewed and agree to&nbsp;
                    <span>
                        <a href='/terms-of-use' target='_blank'  rel='noreferrer'>
                            Terms & Condition
                        </a>
                    </span>
                    , and&nbsp;
                    <span>
                        <a href='/privacy-policy' target='_blank' rel='noreferrer'>
                            Privacy Policy.
                        </a>
                    </span>
                </label>
                <br /><br /><br />
                <PrimaryFormButton type='submit' disabled={!isChecked}>
                    <span>Contact Us</span>&nbsp;
                    <FontAwesomeIcon icon={faArrowRight} />
                </PrimaryFormButton>
            </ContactFormWrapper>

            <AddressCard>
                <h2>Drop in our office</h2>
                <P>
                    Get in touch to discover the difference we can make, and the difference you can live. 
                    <br />
                    Corporate Office: 2nd Floor, Gomti Plaza Complex, Patrakarpuram Crossing, Gomti Nagar, Lucknow - 226010, A-70, Indira Nagar, Lucknow - 226016
                </P>

                <h2>Site Office</h2>
                <P>Power House Chauraha, Aashiyana, Lucknow</P>

                <h2>Contact at</h2>
                <P>9692171777 <br /> <a style={{color: 'white'}} href="mailto:info@celestemall.com">info@celestemall.com</a><br /><br />Project RERA No.: UPRERAPRJ187993 <br />Available at: https://www.up-rera.in/</P>
            </AddressCard>

            {/* <a href='/pdf/celeste-mall-brochure.pdf'>Celeste Mall Brochure</a> */}
        </PageContent>
    )
}